module.exports = "<div class=\"wrapper\">\r\n\r\n  <app-admin-header></app-admin-header>\r\n  <!-- Left side column. contains the logo and sidebar -->\r\n  <app-admin-left-side></app-admin-left-side>\r\n\r\n  <!-- Content Wrapper. Contains page content -->\r\n  <router-outlet></router-outlet>\r\n  <!-- /.content-wrapper -->\r\n  <app-admin-footer></app-admin-footer>\r\n\r\n  <!-- Control Sidebar -->\r\n  <app-admin-control-sidebar></app-admin-control-sidebar>\r\n  <!-- /.control-sidebar -->\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/projects/angular/DineroAgil/src/app/admin/admin.component.html
// module id = ../../../../../src/app/admin/admin.component.html
// module chunks = main